import { Grid, Typography } from '@mui/material';
import { SelectApplications, SelectMarketingProcess, SelectPlatform } from 'components/common';
import type { FC } from 'react';
import { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const AppPlatformForm: FC = () => {
  const { trigger, getFieldState, setValue } = useFormContext();
  const isDirty = getFieldState('marketingProcess').isDirty;

  useEffect(() => {
    if (isDirty)
      void trigger('marketingProcess');
  }, [trigger, isDirty]);

  const handleChange = useCallback(() => {
    setValue('selectedCampaigns', [], { shouldValidate: true });
    setValue('selectedAdSets', [], { shouldValidate: true });
  }, [setValue]);

  return (
    <>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Choose App & Platform
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <SelectApplications />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectPlatform />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectMarketingProcess handleChange={handleChange} />
        </Grid>
      </Grid>
    </>
  );
};
export default AppPlatformForm;